export const LEARNER_KEY = "uvc_active_learner";

export function getActiveLearner() {
  try {
    const raw = localStorage.getItem(LEARNER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setActiveLearner(learner) {
  if (!learner) {
    localStorage.removeItem(LEARNER_KEY);
    return;
  }
  localStorage.setItem(LEARNER_KEY, JSON.stringify(learner));
}
